module.exports = __webpack_public_path__ + "img/w44.f36cc40f.svg";